export const createAudioContext = (deviceId) => {
    return new AudioContext({ sinkId: deviceId });
}
